enum FontWeight {
    Normal = 'Normal',
    Medium = 'Medium',
    Bold = 'Bold',
}

export default FontWeight
